export enum GridType {
    FOR_ME,
    BY_ME,
    FOR_MY_TEAM,
}
